import { ApolloClient } from "@apollo/client";
import { cache } from "./cache";

const client = new ApolloClient({
  cache,
  uri: "https://scardor-api.herokuapp.com/graphql",
});

export default client;